import { STATUS_CODE_SERVER } from "../../Constants";
export const ValidatorError = (ServerResponse) => {
  let Errosvr;
  if (ServerResponse.response) {
      if(ServerResponse.response.data.errMessage ){
        Errosvr = { data :  {...ServerResponse.response.data , ...{ errorNumber:ServerResponse.response.status}}};  
      }else {
        Errosvr = { data :  {...{  errorMessage: "BAD_REQUEST"} , ...{ errorNumber:ServerResponse.response.status}}};  
      }
  } else {
    Errosvr = {
      data: {
        errorMessage: "CONECTION_ERROR",
        errorNumber : STATUS_CODE_SERVER.NOT_FOUND
      },
    };
  }
  console.log(ServerResponse);
  return Errosvr;
};
